import React from "react";

function Footer(props) {
  return (
    <div>
      <footer>
        <p>&copy; 2019 Campus Manager</p>
      </footer>
    </div>
  );
}

export default Footer;
